import React from "react";
import { createPortal } from "react-dom";

export default function FullscreenOverlay({ children }) {
  return createPortal(
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 999999, // très élevé pour passer au-dessus
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}>
      {children}
    </div>,
    document.body // render dans body pour sortir de tout stacking context
  );
}
